import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { useFixedIncomeSellAssetController } from '../../../../../hooks/products/FixedIncomeSell';
import { LateralBar } from '../../../components/LateralBar';
import { ListLoadingItemTablet } from '../ListLoadingItem/tablet';

import { FixedIncomeListItemTypes } from '.';

export const FixedIncomeListItemTablet: React.FC<FixedIncomeListItemTypes.Props> = ({ offer }) => {
  const id = offer.productIdNormalized;
  const {
    amountItem,
    handleChangeAmountItem,
    errorMessage,
    hasError,
    netFinancialValue,
    netFinancialValueFormatted,
  } = useFixedIncomeSellAssetController(offer);

  const { infoGetter, selectedTab } = useGlobalAssetContext();

  const completeOffer = { ...offer, orderQuantity: amountItem || 0, orderValue: netFinancialValue };

  const { Button, isSelected, forceLoading } = infoGetter(
    'fixedIncomeSell',
    completeOffer,
    'productIdNormalized'
  );

  if (forceLoading) {
    return <ListLoadingItemTablet />;
  }

  const middleInfos = [
    {
      label: 'Quantidade disponível',
      value: <UI.Text color="neutral.dark">{offer.availableQuantityNormalized}</UI.Text>,
    },
    {
      label: 'IR',
      value: <UI.Text color="neutral.dark">{offer.irFormatted}</UI.Text>,
    },
    {
      label: 'Valor líquido',
      value: <UI.Text color="neutral.dark">{netFinancialValueFormatted}</UI.Text>,
    },
    {
      label: 'Disponível em conta',
      value: <UI.Text color="neutral.dark">{offer.availableInAccountNormalized}</UI.Text>,
    },
  ];

  return (
    <TableContent
      direction="row"
      space={0}
      p={0}
      px={Spacing['inline.xxxs']}
      isHighlighted={isSelected}>
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between" alignItems="center">
          <VStack space={Spacing['stack.quarck']}>
            <UI.Text variant="semibold" color="neutral.darkest">
              {offer.issuerFullName}
            </UI.Text>
          </VStack>
        </HStack>
        <HStack justifyContent="space-between">
          {middleInfos.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label}>
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack space={Spacing['inline.xxxs']} justifyContent="space-between" w="full">
          <VStack space={Spacing['stack.quarck']} flexGrow={1}>
            <UI.Text color="neutral.black" variant="semibold">
              Quantidade a resgatar
            </UI.Text>
            <VStack flex={1}>
              <UI.InputStepper
                stepperValue={1}
                max={offer.availableAmount}
                min={1}
                name={`fixed-income-amount-order-input-${id}`}
                keyboardType="numeric"
                fontSize={Typography['fontsize.md']}
                defaultValue={amountItem || 0}
                onChange={handleChangeAmountItem}
                showErrorMessage={false}
                {...(hasError && {
                  customError: errorMessage,
                  showErrorMessage: true,
                })}
              />
            </VStack>
          </VStack>
          <Stack alignSelf="flex-end">
            <Button
              id={selectedTab.typeGetterId}
              offer={completeOffer}
              isDisabled={hasError}
              productContextConstant={selectedTab}
            />
          </Stack>
        </HStack>
      </VStack>
    </TableContent>
  );
};
